import styled from 'styled-components';
import { Image as SemanticImage } from 'semantic-ui-react';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Image = styled(SemanticImage)`
  &.ui.image {
    max-height: 300px;
  }
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin: 22px 0;
`;

export const ContainerHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  margin-bottom: 20px;
`;

export const Title = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.textSecondary};
  font-size: 16px;
  font-family: Roboto;
  margin-top: 20px;
`;

export const QuestionOrder = styled(TextLayoutComponent.Bold)`
  color: ${(props) => props.theme.color.textSecondary};
  font-size: 16px;
  font-family: Roboto;
`;
